<template>
  <div class="circle-graph" ref="circleGraph">
    <svg
      viewBox="0 0 234 234"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      ref="svgComponent"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g stroke-width="11">
          <circle stroke="#C1C1C3" cx="117" cy="117" r="111.5" />
          <path
            d="M117,5.5 C98.7739281,5.5 81.5686195,9.87130835 66.3773857,17.6261947 C48.0052114,27.0049013 32.5781228,41.3285201 21.8495656,58.8418334 C11.4770472,75.7739484 5.5,95.689136 5.5,117 C5.5,147.789875 17.9800626,175.664875 38.1575939,195.842406 C58.3351252,216.019937 86.2101252,228.5 117,228.5 C147.789875,228.5 175.664875,216.019937 195.842406,195.842406 C216.019937,175.664875 228.5,147.789875 228.5,117 C228.5,91.9009789 220.208024,68.738277 206.211638,50.1040883 C191.875692,31.0178244 171.55903,16.6787276 148.041512,9.87653399 C138.187612,7.02639747 127.772082,5.5 117,5.5 Z"
            transform="translate(117.000000, 117.000000) scale(-1, 1) translate(-117.000000, -117.000000)"
            stroke="#5C2D91"
            ref="path"
            stroke-linecap="round"
            :stroke-dasharray="strokeDashArray"
            :stroke-dashoffset="strokeDashOffset"
          />
        </g>
      </g>
    </svg>
    <div class="circle-graph__info">
      <div class="circle-graph__info-wrapper">
        <p class="circle-graph__percentage">{{Math.floor(shownPercentage * 100)}}%</p>
        <p class="circle-graph__description" v-if="description">{{description}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { vuexGetters } from "../../store";

export default {
  name: "CircleGraph",
  props: {
    maxPercentage: {
      type: Number,
      default: 100
    },
    description: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      initialPathLength: this.$refs["path"]
        ? this.$refs["path"].getTotalLength()
        : 0,
      percentageCap: this.maxPercentage / 100,
      currentPercentage: 0.01,
      observer: null,
      hasListener: false
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(this.observerCallback);
    this.observer.observe(this.$refs.svgComponent);
    this.percentageCap = this.maxPercentage / 100;
    this.updateInitialPathLength();
  },
  computed: {
    ...mapGetters({ visibleHeight: vuexGetters.VISIBLE_HEIGHT }),
    pathLength() {
      return this.initialPathLength;
    },
    strokeDashArray() {
      return `${this.pathLength} ${this.pathLength}`;
    },
    strokeDashOffset() {
      return this.pathLength * (1 - this.shownPercentage);
    },
    shownPercentage() {
      return this.currentPercentage > this.percentageCap
        ? this.percentageCap
        : this.currentPercentage;
    }
  },
  methods: {
    updateInitialPathLength() {
      this.initialPathLength = this.$refs.path
        ? this.$refs.path.getTotalLength()
        : 0;
    },
    observerCallback(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasListener) {
          this.hasListener = true;
          window.addEventListener("scroll", this.updatePercentage);
        } else if (!entry.isIntersecting && this.hasListener) {
          this.hasListener = false;
          window.removeEventListener("scroll", this.updatePercentage);
        }
      });
    },
    calcPercentage() {
      const max = this.visibleHeight.height * 0.5;
      const containerOffset = this.$refs.circleGraph.getBoundingClientRect();
      const offsetTop = containerOffset.top - max;
      let currentOffset = 100;
      if (offsetTop <= 0) {
        currentOffset = 0;
      } else if (offsetTop >= max) {
        currentOffset = max;
      } else {
        currentOffset = offsetTop;
      }
      return 1 - currentOffset / max;
    },
    updatePercentage() {
      let newPercentage = this.calcPercentage() * this.percentageCap;
      this.currentPercentage = newPercentage;
    }
  }
};
</script>

<style lang="scss" scoped>
.circle-graph {
  display: block;
  margin: 20px 0;
  position: relative;

  &__info {
    color: $eminence;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px;
  }

  &__percentage {
    display: block;
    font-size: 3.25rem;
    line-height: 3.875rem;
    font-weight: 900;
    margin-bottom: 10px;
  }

  &__description {
    display: block;
    font-size: 0.8125rem;
    line-height: 1.0625rem;

    @media screen and (min-width: 544px) {
      font-size: 1rem;
      line-height: 1.0625rem;
    }
  }
}
</style>